import { render, staticRenderFns } from "./Asignado.vue?vue&type=template&id=28378c64"
import script from "./Asignado.vue?vue&type=script&lang=js"
export * from "./Asignado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports